import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';
import { FontSizes, FontWeights, LabelWidthValues, LineHeights } from '../../../../types/common/types';

export const templatePackageScanModesForm = document.createElement('template');

templatePackageScanModesForm.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='package-scan-modes-form-wrapper'>
    <gz-title fontSize='${FontSizes.PARAGRAPH_11}' fontWeight='${FontWeights.SEMIBOLD}' class='form-subtitle-info' id='package-scan-mode-title'></gz-title>

    <gz-text fontSize='${FontSizes.HEADING_6}' class='mt-1 mb-1' id='package-scan-mode-subtitle'></gz-text>
    <div class='form-section'>
      <gz-form-field id='package-scan-modes-form-field' class='label-mw-150' label=''>
        <gz-radio-group id='package-scan-modes-group' gz-form-input >
          <gz-radio id='package-scan-mode-automatic'></gz-radio>
          <gz-text fontSize='${FontSizes.PARAGRAPH_12}' class='helper-text automatic-text-spacing' id='package-scan-mode-automatic-subtitle'></gz-text>
          <gz-info-box id='central-scan-warning' class='info-box-style ml-3' severity='warning' class='info-box-style hidden'></gz-info-box>
          <gz-radio class='mt-2' id='package-scan-mode-custom' extraTopPaddingOnCheck></gz-radio>
        </gz-radio-group>
      </gz-form-field>
    </div>

    <div id='custom-wrapper'>
      <div class='form-section flex-group'>
        <gz-form-field id='scan-modes-computers' label=''>
          <gz-dropdown gz-form-input type='dropdown' labelWidth='${LabelWidthValues.MEDIUM}'></gz-dropdown>
        </gz-form-field>
        <gz-form-field id='scan-modes-computers-fallback-checkbox' class='flex-group fallback-checkbox'>
          <gz-checkbox class='form-field-input' gz-form-input checked></gz-checkbox>
        </gz-form-field>
        <gz-form-field id='scan-modes-computers-fallback' class='second-dropdown' label=''>
          <gz-dropdown gz-form-input type='dropdown' labelWidth='${LabelWidthValues.MEDIUM}'></gz-dropdown>
        </gz-form-field>
      </div>


      <div class='form-section flex-group'>
        <gz-form-field id='scan-modes-virtual-machines' label=''>
          <gz-dropdown gz-form-input type='dropdown' labelWidth='${LabelWidthValues.MEDIUM}''></gz-dropdown>
        </gz-form-field>
        <gz-form-field id='scan-modes-virtual-machines-fallback-checkbox' class='flex-group fallback-checkbox'>
          <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        </gz-form-field>
        <gz-form-field id='scan-modes-virtual-machines-fallback' class='second-dropdown' label='' disabled>
          <gz-dropdown gz-form-input type='dropdown' labelWidth='${LabelWidthValues.MEDIUM}'></gz-dropdown>
        </gz-form-field>
      </div>

      <div class='form-section flex-group' id='ec2-wrapper'>
        <gz-form-field id='scan-modes-containers-ec2' label=''>
          <gz-dropdown gz-form-input type='dropdown' labelWidth='${LabelWidthValues.MEDIUM}'></gz-dropdown>
        </gz-form-field>
        <gz-form-field id='scan-modes-containers-ec2-fallback-checkbox' class='flex-group fallback-checkbox'>
          <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        </gz-form-field>
        <gz-form-field id='scan-modes-containers-ec2-fallback' class='second-dropdown' label=''>
          <gz-dropdown gz-form-input type='dropdown' labelWidth='${LabelWidthValues.MEDIUM}'></gz-dropdown>
        </gz-form-field>
      </div>

      <div class='form-section flex-group' id='azure-wrapper'>
        <gz-form-field id='scan-modes-containers-azure' label=''>
          <gz-dropdown gz-form-input type='dropdown' class='dropdown-form-field' labelWidth='${LabelWidthValues.MEDIUM}'></gz-dropdown>
        </gz-form-field>
        <gz-form-field id='scan-modes-containers-azure-fallback-checkbox' class='flex-group fallback-checkbox'>
          <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        </gz-form-field>
        <gz-form-field id='scan-modes-containers-azure-fallback' class='second-dropdown' label=''>
          <gz-dropdown gz-form-input type='dropdown' labelWidth='${LabelWidthValues.MEDIUM}'></gz-dropdown>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
